import "../styles/header.css";
import logo from "../images/logo.png";
import menu from "../images/menu.svg";
import close from "../images/close.svg";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

function Header() {
  const location = useLocation();

  const companyRef = useRef(null);
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);
  const mobileRef = useRef(null);

  const [activeBarPosition, setActiveBarPosition] = useState("");
  const [dropdownActive, setDropDownActive] = useState(false);
  const [mobileDropdown, setMobileDropDown] = useState(false);

  useEffect(() => {
    if (location.pathname === "/products") {
      setActiveBarPosition("products");
      setDropDownActive(false);
      setMobileDropDown(false);
    } else if (location.pathname === "/about-us" || location.pathname === "/gallery") {
      setActiveBarPosition("company");
      setDropDownActive(false);
      setMobileDropDown(false);
    } else if (location.pathname === "/faqs") {
      setActiveBarPosition("faq");
      setDropDownActive(false);
      setMobileDropDown(false);
    } else if (location.pathname === "/services") {
      setActiveBarPosition("services");
      setDropDownActive(false);
      setMobileDropDown(false);
    } else {
      setActiveBarPosition("")
      setDropDownActive(false);
      setMobileDropDown(false);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        companyRef.current &&
        !companyRef.current.contains(e.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setDropDownActive(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickMobile = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        mobileRef.current &&
        !mobileRef.current.contains(e.target)
      ) {
        setMobileDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickMobile);
    return () => {
      document.removeEventListener("mousedown", handleClickMobile);
    };
  }, []);

  const openDropdown = (e) => {
    e.stopPropagation();
    setDropDownActive(!dropdownActive);
  };

  const openMobileDropdown = (e) => {
    e.stopPropagation();
    setMobileDropDown(!mobileDropdown);
  };

  return (
    <div className="navbar">
      <Link to="/">
        <img src={logo} alt="logo" className="logo" />
      </Link>
      <div className="nav-links">
        <Link to="/services">
          <p>Services</p>
        </Link>
        <Link to="/products">
          <p>Products</p>
        </Link>
        <div className="company" onClick={openDropdown} ref={companyRef}>
          <p>Company</p>
          <div />
        </div>
        <Link to="/faqs">
          <p>FAQs</p>
        </Link>
      </div>
      <Link to="/contact-us" className="nav-contact">
        <div style={{ display: "flex" }}>
          <p>Contact us</p>
          <div className="arrow" />
        </div>
      </Link>
      <img
        src={mobileDropdown ? close : menu}
        className="nav-menu"
        onClick={openMobileDropdown}
        ref={menuRef}
        alt="menu"
      />
      <canvas className={`nav-active ${activeBarPosition}`} />
      {dropdownActive && (
        <div className="dropdown" ref={dropdownRef}>
          <div className="links">
            <Link to="/about-us">
              <div>
                <p>About us</p>
              </div>
            </Link>
            <Link to="/gallery">
              <div>
                <p>Gallery</p>
              </div>
            </Link>
          </div>
        </div>
      )}
      {mobileDropdown && (
        <div className="mobile-dropdown" ref={mobileRef}>
          <div className="links">
            <Link to="/services">
              <div>
                <p>Services</p>
              </div>
            </Link>
            <Link to="/products">
              <div>
                <p>Products</p>
              </div>
            </Link>
            <Link to="/about-us">
              <div>
                <p>About us</p>
              </div>
            </Link>
            <Link to="/gallery">
              <div>
                <p>Gallery</p>
              </div>
            </Link>
            <Link to="/faqs">
              <div>
                <p>Faqs</p>
              </div>
            </Link>
            <Link to="/contact-us">
              <div>
                <p>Contact us</p>
              </div>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
